const initialize = () => {
    const twoFactorCfg = JSON.parse(document.querySelector('#two-factor-wrapper').dataset.twoFactorParams);
    setInterval(() => {
        (async () => {
            try {
                const response = await fetch(twoFactorCfg.qrCodeRenewPath, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });
                const { secret, qrCodeImage } = await response.json();

                document.getElementById('qrcode-img').src = qrCodeImage;
                document.getElementById('qrcode-secret').value = secret;
            } catch (error) {
                console.log(['could not renew QR code', error.value]);
            }
        })();
    }, twoFactorCfg.qrCodeLifetime * 1000);
};

export default initialize;
